import React from 'react';
import {
  Switch,
  Text,
  thc,
  Flex,
} from '@flightstats/airframe-react';
import styles from './switch.module.css';
import cn from 'classnames';
import { toTitleCase } from '../../lib/strings';

type StyledSwitchProps = {
  text: string;
  name?: string;
  helperText?: string;
  on: boolean;
  onChange: (value: boolean) => void;
  isDisabled?: boolean;
  textRight?: boolean;
};

export const StyledSwitch: React.FC<StyledSwitchProps> = ({
  text,
  name = text,
  helperText,
  on,
  onChange,
  isDisabled,
  textRight = true,
}) => {
  // Switch doesn't actually prevent the input change for toggles not tied to a specific field
  const toggleSwitch = (value: boolean) => {
    if (!isDisabled) onChange(value);
  };

  // This is so the switch is level with the label next to it, otherwise it's way above it for some reason
  // Inside the export so that we can use 'on' to dynamically add the disabled style
  const SwitchWrapper: React.FC<{
    children: React.ReactNode;
    onClick: (e: any) => any;
    marginBottom: string;
  }> = thc(
    Flex,
    {
      height: 'auto',
    },
    {
      '& div': {
        top: '13%',
        marginBottom: '0',
      },
    },
    on
      ? {
          '& span[disabled]': {
            backgroundColor: '#4da88e !important',
          },
        }
      : {},
  );

  return (
    <SwitchWrapper onClick={e => e.stopPropagation()} marginBottom="5px">
      {!textRight ? (
        <Text inline className={cn(styles.switchText)}>
          {toTitleCase(text)}
          {helperText && (
            <>
              <br />
              <small>{helperText}</small>
            </>
          )}
        </Text>
      ) : (
        <></>
      )}
      <div className={cn(styles.wrapperDiv)}>
        <Switch
          id={name}
          name={name}
          onChange={toggleSwitch}
          on={on}
          disabled={isDisabled}
        />
      </div>
      {textRight && (
        <Text inline className={cn(styles.wrapperText)}>
          {toTitleCase(text)}
          {helperText && (
            <>
              <br />
              <small>{helperText}</small>
            </>
          )}
        </Text>
      )}
    </SwitchWrapper>
  );
};
